import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule, DecimalPipe } from '@angular/common';
import { SubscriptionService, SubscriptionPlan } from '../../services/subscription.service';
import { CheckoutComponent } from '../checkout/checkout.component';

@Component({
  selector: 'app-subscription-expired-modal',
  imports: [CommonModule, DecimalPipe, CheckoutComponent],
  templateUrl: './subscription-expired-modal.component.html',
  styleUrls: ['./subscription-expired-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriptionExpiredModalComponent {
  private router = inject(Router);
  private subscriptionService = inject(SubscriptionService);

  plans = signal<SubscriptionPlan[]>([]);
  loading = signal(false);
  visible = signal(false); // Start hidden
  showCheckout = signal(false);
  selectedPlan = signal<SubscriptionPlan | null>(null);
  subscriptionStatus = signal<string>('inactive');

  ngOnInit() {
    this.checkSubscriptionStatus();
    this.loadPlans();
  }

  checkSubscriptionStatus() {
    this.subscriptionService.getSubscriptionStatus().subscribe({
      next: (status) => {
        this.subscriptionStatus.set(status.status);
        // Zeige Modal nur wenn Abo abgelaufen oder inaktiv ist
        const isExpired = status.status !== 'active';
        this.visible.set(isExpired);
      },
      error: (error) => {
        console.error('Fehler beim Laden des Abo-Status:', error);
        // Bei Fehler Modal nicht anzeigen
        this.visible.set(false);
      }
    });
  }

  loadPlans() {
    this.loading.set(true);
    this.subscriptionService.getAvailablePlans().subscribe({
      next: (plans) => {
        // Filter out trial plan if user already used it
        const filtered = plans.filter(p => p.planKey !== 'trial');
        this.plans.set(filtered);
        this.loading.set(false);
      },
      error: (error) => {
        console.error('Fehler beim Laden der Pläne:', error);
        this.loading.set(false);
      }
    });
  }

  selectPlan(plan: SubscriptionPlan) {
    this.selectedPlan.set(plan);
    this.showCheckout.set(true);
  }

  closeCheckout() {
    this.showCheckout.set(false);
    this.selectedPlan.set(null);
  }

  close() {
    // Nur schließbar wenn Abo aktiv ist
    if (this.subscriptionStatus() === 'active') {
      this.visible.set(false);
    }
  }

  logout() {
    // Clear token and redirect to login
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
    this.close();
  }
}
